
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tarot-astro-signup",
      function () {
        return require("private-next-pages/tarot-astro-signup/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tarot-astro-signup"])
      });
    }
  